export const CONFIG = {
  BASE_URL_API: process.env.REACT_APP_API_ENDPOINT || '',
  API_KEY: process.env.REACT_APP_API_KEY || '',
  AUTH_SECURITY_KEY: process.env.REACT_APP_AUTH_SECURITY_KEY || '',
  REACT_APP_MAPS_PLACE_BASE_URL: process.env.REACT_APP_MAPS_PLACE_BASE_URL || '',
  API_KEY_SECRET: process.env.REACT_APP_API_SECRET || '',
};
